export default __webpack_public_path__ + "static/media/header.9128f19f.svg";